import React from 'react'
import { Link } from 'react-router-dom'
import { delay, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
    containerVariants,
    itemVariants,
    photoVariants,
} from "../variants/variants";
import { contactPersons } from "../data/contact-data";
import ConsentEmbed from "../components/ConsentEmbed";


const Contact = () => {
    const { t } = useTranslation();

    return (
        <div className="grid grid-cols-10 pb-28">
            <motion.div
                initial="hidden"
                whileInView="visible"
                exit="exit"
                variants={containerVariants}

                className="col-start-2 md:col-start-2 col-span-8 md:col-span-8   ">


                <div className='  mt-14'>
                    <motion.h2 variants={itemVariants} className='text-45 mb-7'>{t("contact.title")}</motion.h2>
                    <div className='flex justify-between flex-col md:flex-row'>

                        <motion.h6 variants={itemVariants} className='text-20 mb-6 font-medium'>{t("contact.companyName")}</motion.h6>

                        <motion.div variants={itemVariants} className='   my-7 md:my-0 '>
                            <div className='hover:scale-105 duration-300 cursor-pointer flex space-x-2 h-4'>
                            <img src='/images/icons/zc.svg' />
                            <h6 className='text-16'>{t("contact.eCatalog")}</h6>
                            <img src='/images/icons/zx.svg' />
                            </div>
                        </motion.div>
                    </div>

                </div>


                <div className=' grid grid-cols-1 md:grid-cols-3 gap-10'>

                    <div className=' '>
                        <motion.h6 variants={itemVariants} className='text-24 my-3'>{t("contact.factory")}</motion.h6>
                        <motion.div variants={itemVariants} className='h-px w-full  mb-3 bg-black'></motion.div>

                        <div className='space-y-3 mb-7'>
                            <div className='hover:scale-105 duration-300'>
                                <motion.a variants={itemVariants} href='https://maps.app.goo.gl/kJoFjRys785hLDmR9' target='_blank' className='flex space-x-2 group '>
                                    <img src='/images/contact/2.svg' className='h-6 w-6  object-contain' />
                                    <h6 className='text-20 font-light'>{t("contact.address")}</h6>
                                </motion.a>
                            </div>

                            <div className='hover:scale-105 duration-300'>
                                <motion.a variants={itemVariants} href='tel:+902582691341' target='_blank' className='flex space-x-2'>
                                    <img src='/images/contact/3.svg' className='h-6 w-6 object-contain' />
                                    <h6 className='text-20 font-light'>{t("contact.phone")}</h6>
                                </motion.a>
                            </div>

                            <div className='hover:scale-105 duration-300'>
                                <motion.a variants={itemVariants} href='mailto:doksan@doksan.com' target='_blank' className='flex space-x-2'>
                                    <img src='/images/contact/1.svg' className='h-6 w-6  object-contain' />
                                    <h6 className='text-20 font-light'>{t("contact.email")}</h6>
                                </motion.a>
                            </div>

                        </div>


                    </div>



                    <div className=' mb-10 col-span-3'>
                        <motion.h6 variants={itemVariants} className='text-24 my-3'>{t("contact.corporateContacts")}</motion.h6>
                        <motion.div variants={itemVariants} className='h-px w-full mb-6 bg-black'></motion.div>

                        <div className=' grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10'>
                            {contactPersons.map((person) => (
                                <motion.div key={person.id} variants={itemVariants} className=''>
                                    <h6 className='text-18 font-medium text-gray-700 mb-1'>{t(`contact.roles.${person.roleKey}`)}</h6>
                                    <h6 className='text-20 font-semibold mb-1'>{person.name}</h6>
                                    <h6 className='text-16 font-light text-gray-600'>{t(`contact.roles.${person.positionKey}`)}</h6>
                                    <div className=''>
                                        <a href={`tel:${person.phone.replace(/\s/g, '')}`} className='hover:scale-105 duration-300 block text-16 font-light hover:text-blue-600'>{person.phone}</a>
                                        <a href={`mailto:${person.email}`} className='hover:scale-105 duration-300 block text-16 font-light hover:text-blue-600'>{person.email}</a>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                    


                    <div className=' mb-7 col-span-3'>
                        <ConsentEmbed
                            category="functional"
                            title="Dok-San Tekstil Denizli Dokuma Sanayi"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3936.5192720117907!2d29.244183999999997!3d37.80177299999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14c73f1f92866e6d%3A0x9ef3b828faaa57ce!2sDok-San%20Tekstil%20Denizli%20Dokuma%20Sanayi!5e1!3m2!1sen!2str!4v1733234016172!5m2!1sen!2str"
                            className="w-full"
                            iframeClassName="w-full"
                            height={450}
                            width="100%"
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>


                    <motion.div variants={itemVariants}>
                        <a href='https://www.google.com/maps/dir//Dok-San+Tekstil+Denizli+Dokuma+Sanayi,+2.+Organize+Sanayi+Bolgesi,+H%C3%BCsn%C3%BC+%C3%96rnek+Cd.+No:2-4,+20065+Honaz%2FDenizli/@37.801773,29.244184,929m/data=!3m1!1e3!4m9!4m8!1m0!1m5!1m1!1s0x14c73f1f92866e6d:0x9ef3b828faaa57ce!2m2!1d29.244184!2d37.801773!3e0?entry=ttu&g_ep=EgoyMDI0MTIwMS4xIKXMDSoASAFQAw%3D%3D' target='_blank' className='py-3 px-10  inline-flex text-20 border border-black border-opacity-40 hover:scale-105 duration-300'>
                            <h6>{t("contact.getDirections")}</h6>
                        </a>
                    </motion.div>





                </div>





            </motion.div>
        </div>
    )
}

export default Contact
